import * as yup from 'yup';

export const rewardDrinkCreateValidationSchema = {
  name: yup
    .string()
    .min(4, 'Name is too short!')
    .max(50, 'Name is too long!')
    .required('Name is required!'),
  rewardIdentity: yup.string().required('Reward Identity is required!'),
  points: yup
    .number()
    .typeError('Points must be a number')
    .min(0, 'Points must be positive')
    .required('Points are required!'),
  waterAmount: yup
    .number()
    .typeError('Water amount must be a number')
    .min(0, 'Water Amount must be positive')
    .required('Water Amount is required!')
};
export const RewardDrinkEditValidationSchema = {
  name: yup
    .string()
    .min(4, 'Name is too short!')
    .max(50, 'Name is too long!')
    .required('Name is required!'),
  rewardIdentity: yup.string().required('Reward Identity is required!'),
  points: yup
    .number()
    .typeError('Points must be a number')
    .min(0, 'Points must be positive')
    .required('Points are required!'),
  waterAmount: yup
    .number()
    .typeError('Water amount must be a number')
    .min(0, 'Water Amount must be positive')
    .required('Water Amount is required!')
};
